import { CSSObject } from '@mui/material';
import React from 'react';

import { DialogActions } from '_lib/components/DialogActions/DialogActions';
import { DialogButton } from '_lib/components/DialogButton/DialogButton';
import { DialogContent } from '_lib/components/DialogContent/DialogContent';
import { DialogContentText } from '_lib/components/DialogContentText/DialogContentText';
import { DialogWrapper } from '_lib/featureComponents/DialogWrapper/DialogWrapper';

import { AsyncDialogProps, useAsyncDialog } from './useAsyncDialog';

export type ConfirmationDialogProps = Omit<AsyncDialogProps, 'dismissable'> & {
  contentText: string | string[];
  cancelButtonText?: string;
  confirmButtonText?: string;
  dialogMaxWidth?: CSSObject['maxWidth'];
};

const ConfirmationDialog = (props: ConfirmationDialogProps) => {
  const { cancelButtonText, confirmButtonText, contentText, dialogMaxWidth, onClose, titleText, ...dialogProps } =
    props;

  const handleCancel = () => {
    onClose({ action: 'CANCEL' });
  };

  const handleConfirm = () => {
    onClose({ action: 'CONFIRM' });
  };

  const textItems: string[] = Array.isArray(contentText) ? contentText : [contentText];

  return (
    <DialogWrapper
      {...dialogProps}
      dismissable={false}
      onClose={onClose}
      sx={[{ '& .MuiPaper-root.MuiDialog-paper': { maxWidth: dialogMaxWidth || '400px' } }]}
      titleText={titleText || 'CONFIRMATION REQUIRED'}>
      {textItems
        .filter((text) => !!text)
        .map((text, index) => (
          <DialogContent key={index}>
            <DialogContentText>{text}</DialogContentText>
          </DialogContent>
        ))}
      <DialogActions>
        <DialogButton color='cancel' onClick={handleCancel} text={cancelButtonText || 'Cancel'} />
        <DialogButton onClick={handleConfirm} text={confirmButtonText || 'Confirm'} />
      </DialogActions>
    </DialogWrapper>
  );
};

export const useConfirmationDialog = () => useAsyncDialog(ConfirmationDialog);
